<template>
  <button
    type="button"
    class="select-race-item-parts"
    :class="{ 'select-race-item-parts__current': current }"
    @click="push"
  >
    <span
      class="select-race-item-parts__round"
      :style="{ 'background-image': `url(${raceImg})`, 'background-position': 'right bottom' }"
    >
      <span v-if="round !== 0">
        <span class="select-race-item-parts__round__label">RD.</span>
        <span class="select-race-item-parts__round__num">{{ round }}</span>
      </span>

      <span class="select-race-item-parts__round__course">
        <img :src="courseImg" :alt="venue" />
      </span>
    </span>

    <span class="select-race-item-parts__data">
      <span class="select-race-item-parts__data__venue">{{ venue }}</span>
      <span class="select-race-item-parts__data__date">{{ raceDate }}</span>
    </span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース一覧画面: レース選択アイテム コンポーネント
 */
export default defineComponent({
  name: 'RaceListItemParts',
  props: {
    current: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Number,
      default: 0,
    },
    courseImg: {
      type: String,
      default: '',
    },
    venue: {
      type: String,
      default: '',
    },
    raceDate: {
      type: String,
      default: '',
    },
    raceImg: {
      type: String,
      default: '',
    },
  },
  mounted() {
    if (this.current) {
      this.$el.scrollIntoView({ behavior: 'smooth', inline: 'center' })
    }
  },
  methods: {
    push() {
      /**
       * ボタンが押下されたことを通知する
       * @event login
       * @type {Object}
       */
      this.$emit('push')
    },
  },
})
</script>

<style lang="scss" scoped>
.select-race-item-parts {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: 144px;
  min-width: 144px;
  text-align: left;
  overflow: hidden;
  padding: 1px;
  @include fontSetTextSmall();

  &::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    display: block;
    content: '';
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  &__current {
    &::after {
      border-width: 2px;
      border-color: #000;
    }
  }

  &__round {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    align-content: flex-end;
    justify-items: flex-start;
    width: 100%;
    height: 5.2em;
    padding: 1em 0.8em;
    color: $white;
    background: center center no-repeat;
    background-size: cover;
    border-radius: 7.5px 7.5px 0 0;
    overflow: hidden;

    > * {
      position: relative;
      z-index: 2;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: block;
      content: '';
      opacity: 0.8;
      border-radius: 9px 9px 0 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 25%, #000000 100%), rgba(0, 0, 0, 20%);
    }

    &__label {
      margin-right: 0.3em;
    }

    &__num {
      @include fontSetTitleBold(28);

      line-height: 1;
    }

    &__course {
      position: absolute;
      right: 17px;
      bottom: 6px;
    }
  }

  &__data {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    justify-items: center;
    width: 100%;
    padding: 6px;
    background: #fff;
    border-radius: 0 0 7.5px 7.5px;

    &__venue {
      width: 100%;
      height: 29px;
      min-height: 29px;
      margin-bottom: 2px;
      font-size: 1.2em;
      word-break: keep-all;
      display: -webkit-box;
      overflow: hidden;

      /* autoprefixer: off */
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    /*
      以下のエラーがでるため、ブロックを分けて記載する。
      `Second Autoprefixer control comment was ignored. Autoprefixer applies control comment to whole block, not to next rules.`
    */

    /* autoprefixer: on */

    &__date {
      width: 100%;
      color: $gray50;
    }
  }
}
</style>
